"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var lodash_1 = require("lodash");
var api_request_1 = require("../../api_request");
var comparison_shopping_page_1 = require("./comparison_shopping_page");
var csp_card_1 = require("./csp_card");
var url_helpers_1 = require("../../shared/url_helpers");
var classNames = require("classnames");
var elog = require("@reverbdotcom/commons/dist/elog");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var componentName = 'BlogEmbedCSPs';
var ComparisonShoppingPageCardManager = /** @class */ (function (_super) {
    tslib_1.__extends(ComparisonShoppingPageCardManager, _super);
    function ComparisonShoppingPageCardManager(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            page: {},
            tracked: false,
        };
        return _this;
    }
    ComparisonShoppingPageCardManager.prototype.componentDidMount = function () {
        var _this = this;
        var _a = this.props, slug = _a.slug, id = _a.id;
        if (slug || id) {
            api_request_1.V3.get(url_helpers_1.cspsFindPath.expand({ slug: slug, id: id }))
                .then(function (response) {
                var page = new comparison_shopping_page_1.default(response);
                _this.setState({ page: page });
                _this.trackImpression(page);
            })
                .fail(function (err) {
                elog.info('blog_csp_embed_missing_404', { slug: slug, id: id, err: err });
            });
        }
    };
    ComparisonShoppingPageCardManager.prototype.trackImpression = function (page) {
        if (this.state.tracked) {
            return;
        }
        tracker_1.trackView({
            componentName: componentName,
            type: tracker_1.CSP_TYPE,
            ids: [page.id],
            context: {
                comparison_shopping_pages: [page.asEvent()],
            },
        });
        this.setState({ tracked: true });
    };
    ComparisonShoppingPageCardManager.prototype.render = function () {
        if (lodash_1.isEmpty(this.state.page)) {
            return null;
        }
        var classes = classNames('csp-embed-card', { 'csp-embed-card--floated': this.props.floated });
        return (React.createElement("section", { className: classes },
            React.createElement(csp_card_1.default, { page: this.state.page })));
    };
    return ComparisonShoppingPageCardManager;
}(React.Component));
exports.default = ComparisonShoppingPageCardManager;
//# sourceMappingURL=csp_card_manager.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/csp_card_manager.js
// module id = LItA
// module chunks = 20 21